// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3zOVy","footer":"ChangeClinic_footer__18SID"};